import axios from "axios";
const BASE_URL = `${process.env.REACT_APP_API_URL}/api/2.0/integrations/hubspot`;

export const hubspotApi = {
    fetchPipelines: async (id): Promise<any> => {
    const response = await axios.get(
      `${BASE_URL}/${id}/deals/pipelines`,
    );
    return response.data;
  },
}